/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Recorder_Duration_Too_ShortInputs */



/**
* | output |
* | --- |
* | "Event duration must be at least 2 seconds to record." |
*
* @param {Audio_Recorder_Duration_Too_ShortInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_recorder_duration_too_short = /** @type {((inputs?: Audio_Recorder_Duration_Too_ShortInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Recorder_Duration_Too_ShortInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("La durée de l'événement doit être d'au moins 2 secondes pour enregistrer.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Das Ereignis muss mindestens 2 Sekunden dauern, um aufgezeichnet zu werden.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Per poter essere registrato, l'evento deve durare almeno 2 secondi.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Для записи длительность события должна составлять не менее 2 секунд.")
	if (locale === "es") return /** @type {LocalizedString} */ ("La duración del evento debe ser de al menos 2 segundos para poder grabar.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("事件持续时间必须至少为 2 秒才能被记录。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("記録するにはイベントの継続時間が少なくとも 2 秒である必要があります。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("रिकॉर्डिंग के लिए इवेंट की अवधि कम से कम 2 सेकंड होनी चाहिए।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("A duração do evento deve ser de pelo menos 2 segundos para ser gravada.")
	return /** @type {LocalizedString} */ ("Event duration must be at least 2 seconds to record.")
});